var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      [
        _c(
          "el-form",
          { attrs: { mode: _vm.dataTransForm, "label-width": "150px" } },
          [
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("developer.dataTransfer")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("developer.abnormalRemind") } },
              [
                _c("el-switch", {
                  attrs: { "active-color": "#13ce66" },
                  on: { change: _vm.dataTransSwtich },
                  model: {
                    value: _vm.dataTransForm.enable,
                    callback: function($$v) {
                      _vm.$set(_vm.dataTransForm, "enable", $$v)
                    },
                    expression: "dataTransForm.enable"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.dataTransForm.enable
              ? [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("developer.remindSet") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: _vm.$t("common.chooseOptions")
                          },
                          model: {
                            value: _vm.dataTransForm.cronExpression,
                            callback: function($$v) {
                              _vm.$set(_vm.dataTransForm, "cronExpression", $$v)
                            },
                            expression: "dataTransForm.cronExpression"
                          }
                        },
                        _vm._l(_vm.cronExpOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("developer.remindSet1")) +
                          "\n          "
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: _vm.$t("common.chooseOptions")
                          },
                          model: {
                            value: _vm.dataTransForm.threshold,
                            callback: function($$v) {
                              _vm.$set(_vm.dataTransForm, "threshold", $$v)
                            },
                            expression: "dataTransForm.threshold"
                          }
                        },
                        _vm._l(_vm.thresholdOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("developer.remindSet2")) +
                          "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.dataTransEmail, function(item, index) {
                    return [
                      _c(
                        "el-form-item",
                        {
                          key: index,
                          attrs: {
                            label:
                              _vm.$t("developer.receiveMail") + "" + (index + 1)
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "padding-left": "0" },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "" },
                                    model: {
                                      value: item.mail,
                                      callback: function($$v) {
                                        _vm.$set(item, "mail", $$v)
                                      },
                                      expression: "item.mail"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  index === 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.addEmail(
                                                "dataTransForm"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("operation.addNew")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _c("i", {
                                        staticClass: "el-icon-remove",
                                        staticStyle: {
                                          color: "#f56c6c",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeEmail(
                                              "dataTransForm",
                                              index
                                            )
                                          }
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  })
                ]
              : _vm._e()
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-form",
          { attrs: { model: _vm.apiForm, "label-width": "150px" } },
          [
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v("API")
            ]),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("developer.abnormalRemind") } },
              [
                _c("el-switch", {
                  attrs: { "active-color": "#13ce66" },
                  on: { change: _vm.apiSwitch },
                  model: {
                    value: _vm.apiForm.enable,
                    callback: function($$v) {
                      _vm.$set(_vm.apiForm, "enable", $$v)
                    },
                    expression: "apiForm.enable"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.apiForm.enable
              ? [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("developer.remindSet") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: _vm.$t("common.chooseOptions")
                          },
                          model: {
                            value: _vm.apiForm.cronExpression,
                            callback: function($$v) {
                              _vm.$set(_vm.apiForm, "cronExpression", $$v)
                            },
                            expression: "apiForm.cronExpression"
                          }
                        },
                        _vm._l(_vm.cronExpOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("developer.remindSet1")) +
                          "\n          "
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: _vm.$t("common.chooseOptions")
                          },
                          model: {
                            value: _vm.apiForm.threshold,
                            callback: function($$v) {
                              _vm.$set(_vm.apiForm, "threshold", $$v)
                            },
                            expression: "apiForm.threshold"
                          }
                        },
                        _vm._l(_vm.thresholdOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("developer.remindSet2")) +
                          "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.apiEmail, function(item, index) {
                    return [
                      _c(
                        "el-form-item",
                        {
                          key: index,
                          attrs: {
                            label:
                              _vm.$t("developer.receiveMail") + "" + (index + 1)
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "padding-left": "0" },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "" },
                                    model: {
                                      value: item.mail,
                                      callback: function($$v) {
                                        _vm.$set(item, "mail", $$v)
                                      },
                                      expression: "item.mail"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  index === 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.addEmail("api")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("operation.addNew")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _c("i", {
                                        staticClass: "el-icon-remove",
                                        staticStyle: {
                                          color: "#f56c6c",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeEmail("api", index)
                                          }
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  })
                ]
              : _vm._e()
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-form",
          { attrs: { model: _vm.apiReportForm, "label-width": "150px" } },
          [
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("developer.apiReport")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("developer.statisticsRemind") } },
              [
                _c("el-switch", {
                  attrs: { "active-color": "#13ce66" },
                  on: { change: _vm.apiReportSwitch },
                  model: {
                    value: _vm.apiReportForm.enable,
                    callback: function($$v) {
                      _vm.$set(_vm.apiReportForm, "enable", $$v)
                    },
                    expression: "apiReportForm.enable"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.apiReportForm.enable
              ? [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("developer.statisticsReport") } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.daySwitch },
                              model: {
                                value: _vm.dayChecked,
                                callback: function($$v) {
                                  _vm.dayChecked = $$v
                                },
                                expression: "dayChecked"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("developer.daily")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-time-picker", {
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              disabled: !_vm.dayChecked,
                              clearable: false
                            },
                            model: {
                              value: _vm.dayTime,
                              callback: function($$v) {
                                _vm.dayTime = $$v
                              },
                              expression: "dayTime"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("developer.dailyTips"),
                                placement: "bottom"
                              }
                            },
                            [_c("i", { staticClass: "el-icon-info" })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticStyle: { margin: "10px 0" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.weekSwitch },
                              model: {
                                value: _vm.weekChecked,
                                callback: function($$v) {
                                  _vm.weekChecked = $$v
                                },
                                expression: "weekChecked"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("developer.week")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-time-picker", {
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              disabled: !_vm.weekChecked,
                              clearable: false
                            },
                            model: {
                              value: _vm.weekTime,
                              callback: function($$v) {
                                _vm.weekTime = $$v
                              },
                              expression: "weekTime"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("developer.weekTips"),
                                placement: "bottom"
                              }
                            },
                            [_c("i", { staticClass: "el-icon-info" })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.monthSwitch },
                              model: {
                                value: _vm.monthChecked,
                                callback: function($$v) {
                                  _vm.monthChecked = $$v
                                },
                                expression: "monthChecked"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("developer.month"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-time-picker", {
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              disabled: !_vm.monthChecked,
                              clearable: false
                            },
                            model: {
                              value: _vm.monthTime,
                              callback: function($$v) {
                                _vm.monthTime = $$v
                              },
                              expression: "monthTime"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("developer.monthTips"),
                                placement: "bottom"
                              }
                            },
                            [_c("i", { staticClass: "el-icon-info" })]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.apiReportEmail, function(item, index) {
                    return [
                      _c(
                        "el-form-item",
                        {
                          key: index,
                          attrs: {
                            label:
                              _vm.$t("developer.receiveMail") + "" + (index + 1)
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "padding-left": "0" },
                                  attrs: { span: 8 }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "" },
                                    model: {
                                      value: item.mail,
                                      callback: function($$v) {
                                        _vm.$set(item, "mail", $$v)
                                      },
                                      expression: "item.mail"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  index === 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.addEmail("apiReport")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("operation.addNew")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _c("i", {
                                        staticClass: "el-icon-remove",
                                        staticStyle: {
                                          color: "#f56c6c",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeEmail(
                                              "apiReport",
                                              index
                                            )
                                          }
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  })
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { staticStyle: { "text-align": "center" } },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.sumbitAppMsg } },
              [_vm._v("\n        " + _vm._s(_vm.$t("operation.confirm")))]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1faeb720", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1faeb720","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developer/appSetting/appMessage.vue
// module id = null
// module chunks = 